// extracted by mini-css-extract-plugin
export default {"input":"y_-z","button":"z_-z","selected":"A_-z","unavailable":"B_-z","oos":"C_-z","paperCutDisabledOverlay":"D_-z","image":"E_-z"};